<template>
  <v-content v-if="quote && copy">
    <Header title="Add company" />
    <v-container>
      <v-card>
        <v-card-text>
          <v-alert :value="true" type="info" outline>
            Please provide company name and contact details
          </v-alert>
          <v-form ref="formCompanyAdd" v-model="valid" lazy-validation>
            <v-text-field
              v-model="copy.name"
              label="Name"
              :rules="valueRules"
              outline
            />
            <v-text-field
              v-model="copy.email"
              label="Email address"
              prepend-icon="email"
              outline
            />
            <v-textarea
              v-model="copy.address"
              label="Company address (including postcode)"
              prepend-icon="domain"
              outline
            />
            <v-btn @click="submitCompanyAdd" color="success"
              ><v-icon>save</v-icon>&#160;Save</v-btn
            >
            <v-btn @click="redirect">Cancel</v-btn>
          </v-form>
        </v-card-text>
      </v-card>
    </v-container>
  </v-content>
</template>

<script>
import Header from "@/components/Header";
import nbmlaw from "@/apis/nbmlaw";
export default {
  name: "IndividualAdd",
  components: { Header },
  data() {
    return {
      quote: null,
      copy: null,
      valid: false,
      valueRules: [(v) => !!v || "Value is required"]
    };
  },
  methods: {
    async fetchQuote() {
      const response = await nbmlaw.get(
        `/cors/open/sales/quotes/${this.$route.params.quoteId}/instructionConfirmation`,
        {
          params: {
            salesUid: this.$route.params.salesUid
          }
        }
      );
      // console.log(response.data);
      this.quote = response.data;
    },
    redirect() {
      this.$router.push({
        name: "instructionConfirmation",
        params: {
          quoteId: this.$route.params.quoteId,
          salesUid: this.$route.params.salesUid
        }
      });
    },
    submitCompanyAdd() {
      if (this.$refs.formCompanyAdd.validate()) {
        this.updateCompany();
      }
    },
    async updateCompany() {
      await nbmlaw.put(
        `/cors/open/sales/quotes/${this.$route.params.quoteId}/company`,
        this.copy,
        {
          params: {
            salesUid: this.$route.params.salesUid
          }
        }
      );
      this.redirect();
    }
  },
  watch: {
    "$route.params.quoteId": {
      immediate: true,
      handler() {
        this.fetchQuote();
      }
    },
    quote: {
      handler() {
        if (this.quote.company) {
          this.copy = JSON.parse(JSON.stringify(this.quote.company));
        } else {
          this.copy = {
            name: "",
            email: "",
            address: ""
          };
        }
      }
    }
  }
};
</script>